module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sales_recovered":"Sales recovered","potential_sales":"Potential sales","to_be_contacted":"To be contacted","no_leads_found":"No leads found","contacted":"Contacted"},"id":{"sales_recovered":"Penjualan","potential_sales":"Potensi Penjualan","to_be_contacted":"Perlu dihubungi","no_leads_found":"Tidak ada lead","contacted":"Telah dihubungi"}}')
  delete Component.options._Ctor
}
